import type { RootState } from 'store'

export const getUserCountry = ({ user }: RootState) => {
  return user.countryCode || 'US'
}

export const getUserLatLng = ({ user }: RootState) => {
  return `${user.latitude || 0.0},${user.longitude || 0.0}`
}

export const getIsRegisteredForOnRamp = ({ user }: RootState) => {
  return user.isRegisteredForOnRamp
}

export const getUserId = ({ user }: RootState) => {
  return user.userId
}

export const getUserName = ({ user }: RootState) => {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`
  }
  return ''
}

export const getUserFirstName = ({ user }: RootState) => {
  return user.firstName
}

export const getIsLoggedIn = ({ user }: RootState) => {
  return Boolean(user.userId)
}

export const getIsEmailVerified = ({ user }: RootState) => {
  return Boolean(user.emailVerified)
}

export const getUser = ({ user }: RootState) => {
  return user
}
